<div class="container vh-100 d-flex justify-content-center align-items-center">
  <div class="row align-items-center">
    <div class="col-lg-6 d-none d-lg-block">
      <img
        src="assets/images/cdblack.png"
        alt="Login Image"
        class="img-fluid"
      />
    </div>

    <div class="col-lg-6 col-md-8 col-sm-12 mx-auto">
      <div class="card shadow-lg mycardpadding mb-0">
        <div class="d-lg-none d-block mylogoimg mb-3">
          <img
            src="assets/images/cdblack.png"
            alt="Login Image"
            class="img-fluid"
          />
        </div>
        <h3 class="text-center mb-3">Forgot Password?</h3>
        <p class="stay-connect text-center mb-0">
          Enter your registered email ID
          <i
            class="bi bi-envelope-at-fill"
            style="color: skyblue; font-size: larger"
          ></i>
          to reset the password
          <i class="bi bi-key-fill" style="color: gold; font-size: larger"></i>
        </p>

        <form class="row g-2 mt-2" #uiForm="ngForm">
          <form-error [form]="form"></form-error>

          <div class="col-12 mb-2">
            <label>Email</label>
            <mat-form-field appearance="outline" class="w-100">
              <mat-icon matPrefix class="opacity-50">
                alternate_email
              </mat-icon>
              <input
                matInput
                type="email"
                name="loginId"
                id="inputEmailAddress"
                placeholder="Enter registered email"
                [(ngModel)]="form.data['loginId']"
                required
              />
            </mat-form-field>
          </div>
          <div class="col-12 d-grid gap-3 mt-4">
            <button
              mat-raised-button
              color="primary"
              type="submit"
              (click)="forgotPassword()"
              class="w-100 fat-button"
              [disabled]="!uiForm.valid"
            >
              <span class="fs-6 tracking-wider">Send Reset Link</span>
            </button>

            <a
              mat-stroked-button
              routerLink="/login"
              class="w-100 back-arrow-button"
            >
              <mat-icon class="me-2">arrow_back</mat-icon>
              <span class="fs-6 tracking-wider">Back to Login</span>
            </a>
          </div>
        </form>
      </div>
    </div>
  </div>
</div>
